import { SHEET_FIELDS } from "./deliverySheetPrint";

const SHEETS = [
  ["trip", "Trip Sheet"],
  ["loading", "Loading Sheet"],
];

/**
 * A distributor's own format of the trip and loading sheet prints: the title, and the columns with their headings, in the order
 * printed. A sheet with "Use a custom format" off prints in the default format.
 */
const SheetPrintLayouts = ({ value, onChange }) => {
  const update = (sheet, layout) => onChange({ ...value, [sheet]: layout });

  const toggleCustom = (sheet, on) => {
    const layout = value[sheet] || {};
    update(sheet, { ...layout, columns: on ? SHEET_FIELDS[sheet].map(([key, heading]) => ({ key, heading })) : [] });
  };

  const toggleColumn = (sheet, key, heading, on) => {
    const layout = value[sheet] || {};
    const columns = layout.columns || [];
    update(sheet, { ...layout, columns: on ? [...columns, { key, heading }] : columns.filter((column) => column.key !== key) });
  };

  const setHeading = (sheet, key, heading) => {
    const layout = value[sheet] || {};
    update(sheet, { ...layout, columns: layout.columns.map((column) => (column.key === key ? { ...column, heading } : column)) });
  };

  const move = (sheet, index, step) => {
    const layout = value[sheet] || {};
    const columns = [...layout.columns];
    [columns[index], columns[index + step]] = [columns[index + step], columns[index]];
    update(sheet, { ...layout, columns });
  };

  return (
    <div style={{ margin: "20px 0" }}>
      <h3 style={{ fontWeight: 600 }}>Trip sheet and loading sheet print</h3>
      <div className="page-subtitle">The default format is used until a custom format is switched on for the sheet.</div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 24, marginTop: 8 }}>
        {SHEETS.map(([sheet, label]) => {
          const layout = value[sheet] || {};
          const columns = layout.columns || [];
          const custom = columns.length > 0;
          const unused = SHEET_FIELDS[sheet].filter(([key]) => !columns.some((column) => column.key === key));
          return (
            <div key={sheet}>
              <h4 style={{ fontWeight: 600 }}>{label}</h4>
              <div className="form-group">
                <label htmlFor={`${sheet}-sheet-title`}>Title on the print</label>
                <input
                  id={`${sheet}-sheet-title`}
                  value={layout.title || ""}
                  maxLength={60}
                  placeholder={label}
                  onChange={(e) => update(sheet, { ...layout, title: e.target.value })}
                />
              </div>
              <label style={{ display: "flex", gap: 8, alignItems: "center", padding: "6px 0" }}>
                <input type="checkbox" checked={custom} onChange={(e) => toggleCustom(sheet, e.target.checked)} />
                Use a custom format
              </label>
              {custom ? (
                <>
                  {columns.map((column, index) => (
                    <div key={column.key} style={{ display: "grid", gridTemplateColumns: "24px 1fr 32px 32px", gap: 6, alignItems: "center", marginBottom: 4 }}>
                      <input
                        type="checkbox"
                        checked
                        aria-label={`Print ${column.heading || column.key}`}
                        onChange={() => toggleColumn(sheet, column.key, column.heading, false)}
                      />
                      <input value={column.heading || ""} aria-label="Heading" onChange={(e) => setHeading(sheet, column.key, e.target.value)} />
                      <button type="button" className="secondary" style={{ padding: "2px 6px" }} disabled={index === 0} onClick={() => move(sheet, index, -1)} aria-label="Move up">
                        ↑
                      </button>
                      <button
                        type="button"
                        className="secondary"
                        style={{ padding: "2px 6px" }}
                        disabled={index === columns.length - 1}
                        onClick={() => move(sheet, index, 1)}
                        aria-label="Move down"
                      >
                        ↓
                      </button>
                    </div>
                  ))}
                  {unused.length ? (
                    <div style={{ marginTop: 6 }}>
                      <div className="page-subtitle">Not printed:</div>
                      {unused.map(([key, heading]) => (
                        <label key={key} style={{ display: "inline-flex", gap: 6, alignItems: "center", marginRight: 12 }}>
                          <input type="checkbox" checked={false} onChange={() => toggleColumn(sheet, key, heading, true)} />
                          {heading}
                        </label>
                      ))}
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SheetPrintLayouts;
